export const order = 5;
export const routes = {
  path: '/',
  name: 'auditCenterLayout',
  component: () => import('@/views/layout'),
  meta: {
    title: '审核中心',
    guard: {
      role: ['Admin'],
      permission: ['upms:auditCenter'],
    },
  },
  children: [
    {
      path: 'auditCenterPage',
      name: 'auditCenterPage',
      meta: {
        title: '审核中心',
        guard: {
          role: ['Admin'],
          permission: ['upms:auditCenter:auditCenterPage'],
        },
      },
      component: () => import('@/views/auditCenter'),
    },
  ],
};
export const perms = {
  auditCenterPage: [
    {
      title:'批量导入申请结果',
      permission:'upms:auditCenter:auditCenterPage:batchImportApplication'
    },
    {
      title: '批量通过',
      permission: 'upms:auditCenter:auditCenterPage:pass',
    },
    {
      title: '批量驳回',
      permission: 'upms:auditCenter:auditCenterPage:cancel',
    },
    {
      title: '批量导出',
      permission: 'upms:auditCenter:auditCenterPage:exp',
    },
  ],
};
